import React, {FC} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField} from "@mui/material";
import {
    EquipmentRepairRequestStatusEnum,
    useEquipmentRepairRequestAddStatusMutation
} from "../../../../../../graphql/graphQlApiHooks";
import {Box} from "@mui/system";
import {LoadingButton} from "@mui/lab";
interface Props {
    open: boolean,
    onClose: () => void,
    equipmentRepairRequestId: string
}
const CompletedRepairDialog: FC<Props> = ({open, onClose, equipmentRepairRequestId}) => {

    const [comment, setComment] = React.useState('');
    const [addStatus, {loading}] = useEquipmentRepairRequestAddStatusMutation()

    const submitHandler = () => {
        addStatus({
            variables: {
                equipmentRepairRequestId,
                state: {
                    status: EquipmentRepairRequestStatusEnum.Repaired,
                    comment
                }
            }
        }).then(() => {
            onClose();
            setComment('')
        })
    };

    return (
        <Dialog
            open={open}
            onClose={() => {
                onClose();
                setComment('')
            }}
        >

            <DialogTitle>
                Отремонтировано
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Укажите комментарий к заявке, если необходимо
                </DialogContentText>
                <Box
                    mt={2}
                >
                    <TextField
                        label="Комментарий"
                        multiline
                        rows={4}
                        variant="outlined"
                        fullWidth
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        size={'small'}
                    />
                </Box>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={() => {
                        onClose();
                        setComment('');
                    }}
                    size={'small'}
                >
                    Отмена
                </Button>
                <LoadingButton
                    loading={loading}
                    variant={'contained'}
                    size={'small'}
                    onClick={submitHandler}
                >
                    Отремонтировано
                </LoadingButton>
            </DialogActions>

        </Dialog>
    )
}

export default CompletedRepairDialog;